import { EarningsInsight } from '@toggle/toggle';
import React from 'react';

import { TooltipContainer } from '~/components/tooltip-container/TooltipContainer';
import { PosthogTrackingSource } from '~/services/tracking/posthog/constants';
import {
  SubTabsType,
  useEarningsInsightDrawer,
} from '~/widgets/earnings-insight-drawer/useEarningsInsightDrawer';

import { EarningsInsightTooltip } from '../earnings-insight-tooltip/EarningsInsightTooltip';
import * as S from './EarningsInsightIcon.styles';
import { getEarningsInsightIconName } from './utils';
import { usePosthogEvents } from '~/services/tracking/posthog/use-posthog-events/usePosthogEvents';
export interface EarningsInsightIconProps {
  size?: number;
  width?: number;
  height?: number;
  entityTag: string;
  earningsInsight: EarningsInsight;
  isDisabled?: boolean;
  enableHover?: boolean;
  isBordered?: boolean;
  source: PosthogTrackingSource;
  customSize?: { width: number; height: number };
}

export const EarningsInsightIcon = ({
  entityTag,
  earningsInsight,
  isDisabled = false,
  enableHover = true,
  isBordered = true,
  customSize,
  size,
  source,
  ...rest
}: EarningsInsightIconProps) => {
  const { openDrawer } = useEarningsInsightDrawer();
  const { trackInsightIconClicked } = usePosthogEvents();

  const isPreview = earningsInsight.type === 'preview';
  const iconProps = {
    iconName: getEarningsInsightIconName(isPreview, isBordered),
    viewBox: isBordered ? '0 0 30 32' : '0 0 12 12',
  };

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    trackInsightIconClicked(
      source,
      isPreview ? 'earnings_preview' : 'earnings_recap'
    );
    openDrawer({
      entityTag,
      earningsId: earningsInsight.earnings_id,
      subtab: isPreview ? SubTabsType.Preview : SubTabsType.Recap,
      source,
    });
  };

  return (
    <TooltipContainer
      label={
        <EarningsInsightTooltip
          earningsInsight={earningsInsight}
          isPreview={isPreview}
          iconProps={iconProps}
        />
      }
      placement="top-start"
      offsetY={-5}
      offsetX={8}
      hasMaxWidth={false}
      disabled={!enableHover || isDisabled}
      inPortal
      withSafePolygon
    >
      <S.StyledIcon
        {...iconProps}
        {...rest}
        {...(customSize
          ? { width: customSize.width, height: customSize.height }
          : { size })}
        $isDisabled={isDisabled}
        $isBordered={isBordered}
        $enableHover={enableHover}
        onClick={handleClick}
      />
    </TooltipContainer>
  );
};
